import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { routerStateNotFound } from '../../commons/constants/router-state-not-found.constant';
import { RouterStates } from '../../commons/constants/router-states.constant';
import { translationsResolver } from '../../commons/services/translations.resolver';
import { ErrorComponent } from '../error/components/error.component';
import { selectPortalGuard } from './services/select-portal.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/' + RouterStates.login,
    pathMatch: 'full',
  },
  {
    path: RouterStates.errorCode,
    resolve: {
      translations: translationsResolver,
    },
    component: ErrorComponent,
  },
  {
    path: RouterStates.login,
    loadChildren: () => import('../../pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: RouterStates.selectPortal,
    canActivate: [selectPortalGuard],
    loadComponent: () =>
      import('../../pages/select-portal/select-portal.component').then((m) => m.SelectPortalComponent),
  },
  {
    path: RouterStates.selectLanguage,
    loadChildren: () =>
      import('../../pages/select-language/select-language.module').then((m) => m.SelectLanguageModule),
  },
  {
    path: RouterStates.external,
    loadChildren: () => import('../../pages/external/external.module').then((m) => m.ExternalModule),
  },
  {
    path: RouterStates.termsAndConditions,
    loadChildren: () =>
      import('../../pages/terms-and-conditions/terms-and-conditions.module').then((m) => m.TermsAndConditionsModule),
  },
  routerStateNotFound,
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      enableTracing: false,
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [
    // AppPreloadingStrategy
  ],
})
export class AppRoutingModule {}
